import type { AlertColor } from "@mui/material";

import { useStackSnackbarStore } from "../hooks/useStackSnackbarStore";

export const notify = (message: string, type: AlertColor = "success") => {
  useStackSnackbarStore.getState().enqueue({ message, type });
};
